import { IconCircleMinus } from '@rossum/ui/icons/tabler';
import { Box, BoxProps, SvgIcon } from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';
import {
  CONTROL_BAR_DISTANCE,
  GRID_LINE_WIDTH,
  SEPARATOR_HANDLE_SIZE,
} from './constants';

export type SeparatorHandleProps = BoxProps & {
  orientation: 'horizontal' | 'vertical';
  showButton: boolean;
  isInteractive: boolean;
};

export const SeparatorHandle = (props: SeparatorHandleProps) => {
  const [primaryPos, secondaryPos] =
    props.orientation === 'horizontal'
      ? (['top', 'left'] as const)
      : (['left', 'top'] as const);

  return (
    <Box
      {...props}
      style={{
        pointerEvents: props.isInteractive ? 'all' : 'none',
        opacity: props.showButton ? 1 : 0,
        [primaryPos]: -SEPARATOR_HANDLE_SIZE / 2 - GRID_LINE_WIDTH / 2,
        [secondaryPos]:
          -GRID_LINE_WIDTH / 2 -
          SEPARATOR_HANDLE_SIZE / 2 -
          CONTROL_BAR_DISTANCE,
        ...props.style,
      }}
      sx={{
        width: SEPARATOR_HANDLE_SIZE,
        height: SEPARATOR_HANDLE_SIZE,
        position: 'absolute',
        cursor: 'pointer',
        borderRadius: borderRadius('xl'),
        backgroundColor: theme => theme.palette.warning.main,
        color: theme => theme.palette.common.white,
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: theme =>
          theme.transitions.create('opacity', { duration: 150 }),
        ...props.sx,
      }}
    >
      <SvgIcon fontSize="inherit" data-cy="remove-separator-icon">
        <IconCircleMinus />
      </SvgIcon>
    </Box>
  );
};
